import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon, ArrowLeftIcon } from 'lucide-react';
import { useTimerSettings } from '../context/TimerContext';
import { ProductionOverview } from './ProductionOverview';
import { TankStatus } from './TankStatus';
import { GrindingProcess } from './GrindingProcess';
import { MachineStatus } from './MachineStatus';
import { ShippingInfo } from './ShippingInfo';
import { LogList } from './LogList';
type TabType = 'slurry' | 'granular' | 'tanks' | 'machines' | 'shipping' | 'samples';
export function ProductionView() {
  const {
    interval
  } = useTimerSettings();
  const [timeLeft, setTimeLeft] = useState(interval);
  const [activeTab, setActiveTab] = useState<TabType>('slurry');
  useEffect(() => {
    setTimeLeft(interval);
    const timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 0) {
          return interval;
        }
        return prevTime - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [interval]);
  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };
  const getProgressPercentage = () => {
    return (interval - timeLeft) / interval * 100;
  };
  const tabs = [{
    id: 'slurry',
    name: 'CT:Slurry Prod.'
  }, {
    id: 'granular',
    name: 'Granular & Ansätze'
  }, {
    id: 'tanks',
    name: 'Tankbestände'
  }, {
    id: 'machines',
    name: 'Maschinenparameter'
  }, {
    id: 'shipping',
    name: 'Verladung'
  }, {
    id: 'samples',
    name: 'Proben'
  }];
  const renderContent = () => {
    switch (activeTab) {
      case 'slurry':
        return <ProductionOverview data-id="element-763" />;
      case 'granular':
        return <MachineStatus data-id="element-764" />;
      case 'tanks':
        return <TankStatus data-id="element-765" />;
      case 'machines':
        return <GrindingProcess data-id="element-766" />;
      case 'shipping':
        return <ShippingInfo data-id="element-767" />;
      case 'samples':
        return <LogList isCompleted={false} data-id="element-768" />;
      default:
        return null;
    }
  };
  return <div className="space-y-4 max-h-screen" data-id="element-769">
      <div className="bg-white rounded-lg shadow-sm p-3" data-id="element-770">
        <div className="flex justify-between items-center" data-id="element-771">
          <div className="flex items-center gap-4" data-id="element-772">
            <Link to="/production" className="flex items-center text-sm text-gray-600 hover:text-gray-800" data-id="element-773">
              <ArrowLeftIcon size={16} className="mr-1" data-id="element-774" />
              Zurück
            </Link>
            <h2 className="text-base font-bold text-gray-800" data-id="element-775">
              Produktionsübersicht
            </h2>
          </div>
          <div className="flex items-center bg-gray-50 rounded-full px-3 py-1.5 border border-gray-100" data-id="element-776">
            <span className="text-xs text-gray-600 mr-2" data-id="element-777">
              Automatisierte Datenerfassung in
            </span>
            <div className="flex items-center gap-2" data-id="element-778">
              <div className="relative w-5 h-5" data-id="element-779">
                <div className="absolute inset-0 rounded-full" style={{
                background: `conic-gradient(#3498dd ${getProgressPercentage()}%, #f3f4f6 ${getProgressPercentage()}%)`
              }} data-id="element-780">
                  <div className="absolute inset-[2px] rounded-full bg-white flex items-center justify-center" data-id="element-781">
                    <ClockIcon className="text-[#3498dd] w-3 h-3" data-id="element-782" />
                  </div>
                </div>
              </div>
              <span className="font-medium text-xs text-[#3498dd]" data-id="element-783">
                {formatTime(timeLeft)}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm" data-id="element-784">
        <div className="border-b border-gray-200" data-id="element-785">
          <div className="flex overflow-x-auto" data-id="element-786">
            {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id as TabType)} className={`px-4 py-2 text-sm font-medium border-b-2 whitespace-nowrap ${activeTab === tab.id ? 'border-[#3498dd] text-[#3498dd]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-787">
                {tab.name}
              </button>)}
          </div>
        </div>
        <div className="p-4" data-id="element-788">{renderContent()}</div>
      </div>
    </div>;
}